import Vue from 'vue'
import App from './App.vue'
import router from './router'
import AsyncComputed from 'vue-async-computed'
import ODS from '@ods/ods' // eslint-disable-line
import i18n from './lang/i18n.js' // eslint-disable-line
import { closest } from './utils/ie' // eslint-disable-line
import { truncate, formatDate } from './utils/filters' // eslint-disable-line
import LoadScript from 'vue-plugin-load-script'

import '@ods/ods/lib/theme-onesait/index.css'
import store from './store/store.js'

Vue.config.productionTip = false

closest()

Vue.filter('truncate', truncate)
Vue.filter('formatDate', formatDate)
Vue.use(AsyncComputed) // async computed properties added
Vue.use(require('vue-moment')) // momentjs for date treatment
Vue.use(LoadScript) // Load scripts for dashboards if needed
Vue.use(ODS, { i18n: (key, value) => i18n.t(key, value) })

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
